module.exports = __webpack_public_path__ + "img/banks.014e4989.svg";